import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/esnext.map.delete-all.js";
import "core-js/modules/esnext.map.every.js";
import "core-js/modules/esnext.map.filter.js";
import "core-js/modules/esnext.map.find.js";
import "core-js/modules/esnext.map.find-key.js";
import "core-js/modules/esnext.map.includes.js";
import "core-js/modules/esnext.map.key-of.js";
import "core-js/modules/esnext.map.map-keys.js";
import "core-js/modules/esnext.map.map-values.js";
import "core-js/modules/esnext.map.merge.js";
import "core-js/modules/esnext.map.reduce.js";
import "core-js/modules/esnext.map.some.js";
import "core-js/modules/esnext.map.update.js";
import "core-js/modules/esnext.set.add-all.js";
import "core-js/modules/esnext.set.delete-all.js";
import "core-js/modules/esnext.set.difference.js";
import "core-js/modules/esnext.set.every.js";
import "core-js/modules/esnext.set.filter.js";
import "core-js/modules/esnext.set.find.js";
import "core-js/modules/esnext.set.intersection.js";
import "core-js/modules/esnext.set.is-disjoint-from.js";
import "core-js/modules/esnext.set.is-subset-of.js";
import "core-js/modules/esnext.set.is-superset-of.js";
import "core-js/modules/esnext.set.join.js";
import "core-js/modules/esnext.set.map.js";
import "core-js/modules/esnext.set.reduce.js";
import "core-js/modules/esnext.set.some.js";
import "core-js/modules/esnext.set.symmetric-difference.js";
import "core-js/modules/esnext.set.union.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { useApolloClient } from '@vue/apollo-composable';
import { useSubmitEuAlignmentQuestionnaireMutation } from '~/types/types';
import { renderMarkdown } from '~/functions/markdown';
import { euTaxonomyMinimumSafeguardsSectionIxId } from '~/functions/eu-taxonomy';
export default /*#__PURE__*/_defineComponent({
  __name: 'Outro',
  props: {
    questionnaireAssignment: null,
    questionnaireTemplate: null
  },
  setup: function setup(__props) {
    var props = __props;
    var step = ref(1);
    var _useApolloClient = useApolloClient(),
      apolloClient = _useApolloClient.client;
    var _useSubmitEuAlignment = useSubmitEuAlignmentQuestionnaireMutation(),
      submitEuAlignmentQuestionnaire = _useSubmitEuAlignment.mutate,
      submitLoading = _useSubmitEuAlignment.loading;
    function triggerSubmit(isEditable) {
      var _props$questionnaireA;
      submitEuAlignmentQuestionnaire({
        questionnaireId: (_props$questionnaireA = props.questionnaireAssignment.id) !== null && _props$questionnaireA !== void 0 ? _props$questionnaireA : 0,
        isEditable: isEditable
      }).then(function () {
        apolloClient.cache.evict({
          fieldName: 'listMetricAssignments'
        });
        apolloClient.cache.gc();
      });
    }
    function isMainSection(result) {
      var _result$details;
      return !!(result !== null && result !== void 0 && (_result$details = result.details) !== null && _result$details !== void 0 && _result$details.subsectionDetails);
    }
    var allResultsInSync = computed(function () {
      var _props$questionnaireT, _props$questionnaireT2;
      var resultMainSectionIds = props.questionnaireAssignment.questionnaireResults.filter(function (e) {
        return isMainSection(e);
      }).map(function (e) {
        return e === null || e === void 0 ? void 0 : e.sectionId;
      });
      var mainSectionIds = (_props$questionnaireT = props.questionnaireTemplate.sections) === null || _props$questionnaireT === void 0 ? void 0 : (_props$questionnaireT2 = _props$questionnaireT.filter(function (section) {
        return section.ixId !== euTaxonomyMinimumSafeguardsSectionIxId;
      })) === null || _props$questionnaireT2 === void 0 ? void 0 : _props$questionnaireT2.map(function (e) {
        return e.id;
      });
      return mainSectionIds !== undefined && new Set(resultMainSectionIds).isSupersetOf(new Set(mainSectionIds)); // no results yet for newly created sections, so we don't have all alignment info
    });
    var sectionResults = computed(function () {
      var _props$questionnaireT3, _props$questionnaireT4;
      var activitySections = (_props$questionnaireT3 = (_props$questionnaireT4 = props.questionnaireTemplate.sections) === null || _props$questionnaireT4 === void 0 ? void 0 : _props$questionnaireT4.filter(function (section) {
        return section.ixId !== euTaxonomyMinimumSafeguardsSectionIxId;
      })) !== null && _props$questionnaireT3 !== void 0 ? _props$questionnaireT3 : [];
      var sectionOrder = new Map(activitySections.map(function (section, index) {
        return [section.id, index];
      }));
      return props.questionnaireAssignment.questionnaireResults.filter(function (result) {
        return isMainSection(result) && sectionOrder.has(result.sectionId);
      }).sort(function (a, b) {
        var _sectionOrder$get, _sectionOrder$get2;
        return ((_sectionOrder$get = sectionOrder.get(a.sectionId)) !== null && _sectionOrder$get !== void 0 ? _sectionOrder$get : 0) - ((_sectionOrder$get2 = sectionOrder.get(b.sectionId)) !== null && _sectionOrder$get2 !== void 0 ? _sectionOrder$get2 : 0);
      });
    });
    var allQuestionsAnswered = computed(function () {
      return props.questionnaireAssignment.sectionCompletion.every(function (item) {
        return item.isCompleted;
      });
    });
    var isSubmittable = computed(function () {
      return props.questionnaireAssignment.isEditable && allQuestionsAnswered.value;
    });
    return {
      __sfc: true,
      props: props,
      step: step,
      apolloClient: apolloClient,
      submitEuAlignmentQuestionnaire: submitEuAlignmentQuestionnaire,
      submitLoading: submitLoading,
      triggerSubmit: triggerSubmit,
      isMainSection: isMainSection,
      allResultsInSync: allResultsInSync,
      sectionResults: sectionResults,
      allQuestionsAnswered: allQuestionsAnswered,
      isSubmittable: isSubmittable,
      renderMarkdown: renderMarkdown
    };
  }
});